/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AppConfigResponse,
  HTTPValidationError
} from './client.schemas'




/**
 * @summary Get App Config
 */
export const appConfigGetAppConfig = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AppConfigResponse>> => {
    
    return axios.default.get(
      `/app_config`,options
    );
  }


export const getAppConfigGetAppConfigQueryKey = () => {
    return [`/app_config`] as const;
    }

    
export const getAppConfigGetAppConfigQueryOptions = <TData = Awaited<ReturnType<typeof appConfigGetAppConfig>>, TError = AxiosError<HTTPValidationError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appConfigGetAppConfig>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAppConfigGetAppConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof appConfigGetAppConfig>>> = ({ signal }) => appConfigGetAppConfig({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof appConfigGetAppConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type AppConfigGetAppConfigQueryResult = NonNullable<Awaited<ReturnType<typeof appConfigGetAppConfig>>>
export type AppConfigGetAppConfigQueryError = AxiosError<HTTPValidationError>

/**
 * @summary Get App Config
 */
export const useAppConfigGetAppConfig = <TData = Awaited<ReturnType<typeof appConfigGetAppConfig>>, TError = AxiosError<HTTPValidationError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof appConfigGetAppConfig>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getAppConfigGetAppConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



